import { render } from "./App.vue?vue&type=template&id=9d9f6834"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9d9f6834&lang=css"

import exportComponent from "/www/wwwroot/check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__